import { Typography } from "@mui/material";
import type { FC } from "react";
import { formatDate, fromISO8601_DATE, type ISO8601_DATE } from "../../../utils/iso8601";

export const CustomRepeatSumamry: FC<{
  repeatInfo: { number_of_repeats: number; final_occurrence: ISO8601_DATE };
}> = ({ repeatInfo }) => {
  if (repeatInfo.number_of_repeats === 100) {
    // This is a special case for "never" repeat
    return <Typography variant="body1">This event will repeat indefinitely</Typography>;
  }

  if (repeatInfo.number_of_repeats === 0) {
    return (
      <Typography variant="body1">
        This event will not repeat as the end date is before the first recurrence
      </Typography>
    );
  }

  return (
    <Typography variant="body1">
      {`This event will repeat ${repeatInfo.number_of_repeats} times, the last occurrence will be on ${formatDate(fromISO8601_DATE(repeatInfo.final_occurrence))}`}
    </Typography>
  );
};
